import { ITimeFrameObject } from '../editing-directive/i-time-frame-object';
import { ContentControlledEventActionEnum } from '../enums/content-controlled-event-action.enum';

export class MergedCensorshipEvent implements ITimeFrameObject {
  constructor(
    public startsAtMs: number,
    public endsAtMs: number,
    public eventType: string,
    public actionTitle: string,
    public isApproved: boolean,
    public isMitigated: boolean,
  ) {}
  public get actionDisplayName(): string {
    if (this.isApproved) {
      return ContentControlledEventActionEnum[
        ContentControlledEventActionEnum.Approve
      ];
    } else {
      return this.actionTitle;
    }
  }
}
